import { warnIfConnectionLimitCrosses } from './connectionLimit'

import {
  getConnectionTypeOncePicked,
  printMessageForDevelopmentMode,
  disableZoomForDoubleClick,
  doNotShowContextMenu,
  doNotLetDeleteReferenceNode,
  warnForIncompatibleConnection,
  hideModalIfNodeRemoved,
  changeUniqueIdOnCloneNode,
  deleteChildrenNodesWhenDeletingParentNode,
} from './default'

import {
  hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,
  showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,
}  from './newPostback'

import {
  showReferenceModalElementsIfActionButtonHasSpecificValue,
  hideReferenceModalElementsIfActionButtonHasSpecificValue,
}  from './reference'

import {
  toggleOutputConnectionOfNewQuestionOnCreated,
  toggleOutputConnectionOfNewQuestionOnRemoved,
}  from './newQuestion'


import {
  displayComponentListAndCreateNodeOnClick
} from './componentList'

export {
  // Default listeners
  getConnectionTypeOncePicked,
  printMessageForDevelopmentMode,
  disableZoomForDoubleClick,
  doNotShowContextMenu,
  doNotLetDeleteReferenceNode,
  warnForIncompatibleConnection,
  hideModalIfNodeRemoved,
  changeUniqueIdOnCloneNode,

  // Connection limit listener
  warnIfConnectionLimitCrosses,

  // NewPostback listeners
  hideNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,
  showNewPostbackNodeAndModalElementsIfConnectedWithSequenceSingle,

  // Reference listeners
  showReferenceModalElementsIfActionButtonHasSpecificValue,
  hideReferenceModalElementsIfActionButtonHasSpecificValue,

  // New Question listeners
  toggleOutputConnectionOfNewQuestionOnCreated,
  toggleOutputConnectionOfNewQuestionOnRemoved,

  // ComponentList listeners
  displayComponentListAndCreateNodeOnClick,

  deleteChildrenNodesWhenDeletingParentNode,
}